// utils/stripHtml.js
export function stripHtml(html = "") {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, ""); // remove all HTML tags
}
